// extracted by mini-css-extract-plugin
module.exports = {"first":"Frontpage_first__ybsgl","container":"Frontpage_container__1AWhI","next":"Frontpage_next__3Esso"};